import Modal from "react-modal";
import React, { useCallback, useEffect, useState } from "react";
import "./BookingPage.css";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import arrowRight from "../../../assets/images/Chevron Right.svg";
import arrowLeft from "../../../assets/images/Chevron Left.svg";
import axiosInstance from "../../../api";
import useAppContext from "../../context/AppContext";

const customStyles = {
  content: {
    position: "absolute",
    top: "20%",
    left: "0%",
    right: "0%",
    bottom: "0",
    width: "100%",
    height: "80vh",
    borderRadius: "3rem",
    padding: "20px 0px",
  },
};

const BookingPage = ({
  open,
  setOpen,
  clinicId,
  doctorId,
  availabilities,
  unavailabilities,
}) => {
  const navigate = useNavigate();
  const { openSnackbar } = useAppContext();

  const [slots, setSlots] = useState({
    MONDAY: [],
    TUESDAY: [],
    WEDNESDAY: [],
    THURSDAY: [],
    FRIDAY: [],
    SATURDAY: [],
    SUNDAY: [],
  });
  const [slots2, setSlots2] = useState({
    MONDAY: [],
    TUESDAY: [],
    WEDNESDAY: [],
    THURSDAY: [],
    FRIDAY: [],
    SATURDAY: [],
    SUNDAY: [],
  });
  const [selectedTimeSlot, setSelectedTimeSlot] = useState({
    slotId: "",
    availabilityId: "",
  });
  const [openCalender, setOpenCalender] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [firstDate, setFirstDate] = useState(new Date());
  const [visitType, setVisitType] = useState("ONLINE");

  const [bookedSlots, setBookedSlots] = useState([]);
  const [patientTypeDurations, setPatientTypeDurations] = useState({
    new: 20,
    followup: 10,
    online: 15,
    seniorCitizen: 20,
    reportReview: 5,
    emergency: 15,
  });

  const fetchBookedSlots = useCallback(
    async (date) => {
      try {
        const formattedDate = moment(date).format("YYYY-MM-DD");
        if (!doctorId || !clinicId) return;

        const response = await axiosInstance.get(`/appointment/booked-slots`, {
          params: { doctorId, clinicId, date: formattedDate },
        });

        if (response.data.success) {
          setBookedSlots(response.data.bookedRanges || []);
          setPatientTypeDurations(
            response.data.patientTypeDurations || {
              new: 20,
              followup: 10,
              online: 15,
              seniorCitizen: 20,
              reportReview: 5,
              emergency: 15,
            },
          );
        }
      } catch (error) {
        setBookedSlots([]);
      }
    },
    [doctorId, clinicId],
  );

  useEffect(() => {
    if (availabilities?.length) {
      const durationMinutes = patientTypeDurations?.online || 15;

      let generatedSlots = {
        MONDAY: [],
        TUESDAY: [],
        WEDNESDAY: [],
        THURSDAY: [],
        FRIDAY: [],
        SATURDAY: [],
        SUNDAY: [],
      };

      availabilities.forEach((availability) => {
        availability.days.forEach((day) => {
          const availStart = moment(availability.startTime, "HH:mm");
          const availEnd = moment(availability.endTime, "HH:mm");

          let current = availStart.clone();
          let slotIndex = 0;

          while (current.isBefore(availEnd)) {
            const slotStart = current.format("HH:mm");
            const slotEnd = current
              .clone()
              .add(durationMinutes, "minutes")
              .format("HH:mm");

            if (moment(slotEnd, "HH:mm").isAfter(availEnd)) break;

            const slotItem =
              availability.slots[slotIndex] || availability.slots[0];
            let finalOriginalSlotId = "";

            if (slotItem) {
              let rawId =
                typeof slotItem === "object"
                  ? slotItem._id || slotItem.$oid || ""
                  : slotItem;

              rawId = String(rawId);

              if (rawId.includes("_")) {
                finalOriginalSlotId = rawId.split("_")[0];
              } else {
                finalOriginalSlotId = rawId;
              }
            }

            generatedSlots[day].push({
              _id: `${availability._id}_${slotStart}`,
              originalSlotId: finalOriginalSlotId,
              availabilityId: availability._id,
              startTime: slotStart,
              endTime: slotEnd,
            });

            current.add(durationMinutes, "minutes");
            slotIndex++;
          }
        });
      });

      setSlots(generatedSlots);
      setSlots2(generatedSlots);
    }
  }, [availabilities, patientTypeDurations]);

  useEffect(() => {
    if (selectedDate && doctorId && clinicId) {
      fetchBookedSlots(selectedDate);
    }
  }, [selectedDate, doctorId, clinicId, fetchBookedSlots]);

  useEffect(() => {
    let slotFilter = [];
    if (
      moment(selectedDate).format("DD MM YYYY") ===
      moment().format("DD MM YYYY")
    ) {
      const day = moment(selectedDate).format("dddd").toUpperCase();
      const data = { ...slots2 };
      const abc = data[day].filter(
        (x) => moment(x.startTime, "HH:mm") > moment(),
      );
      const slotsData = data;
      slotsData[day] = abc;
      slotFilter = slotsData;
    } else {
      slotFilter = slots2;
    }
    setSlots(slotFilter);
  }, [selectedDate, slots2]);

  const filterUnavaliblity = (slotFilter) => {
    if (unavailabilities?.length && slotFilter?.length) {
      let slotDays = slotFilter.map((x) => {
        return {
          ...x,
          startDate: moment(
            new Date(
              moment(selectedDate).format("MM-DD-YYYY") +
                " " +
                moment(x.startTime, "hh:mm").format("hh:mm A"),
            ),
          ),
          endDate: moment(
            new Date(
              moment(selectedDate).format("MM-DD-YYYY") +
                " " +
                moment(x.endTime, "hh:mm").format("hh:mm A"),
            ),
          ),
        };
      });
      const filterSlot = slotDays.filter((avsl) => {
        if (
          !unavailabilities.some(
            (uasl) =>
              (avsl.startDate.isBefore(new Date(uasl.endDate)) &&
                avsl.startDate.isAfter(new Date(uasl.startDate))) ||
              avsl.startDate.isSame(new Date(uasl.startDate)) ||
              avsl.startDate.isSame(new Date(uasl.endDate)) ||
              (avsl.endDate.isBefore(new Date(uasl.endDate)) &&
                avsl.endDate.isAfter(new Date(uasl.startDate))) ||
              avsl.endDate.isSame(new Date(uasl.startDate)) ||
              avsl.endDate.isSame(new Date(uasl.endDate)),
          )
        ) {
          return true;
        }
        return false;
      });
      return filterSlot;
    }
    return slotFilter || [];
  };

  const slideLeft = () => {
    let slider = document.getElementById("slider");
    slider.scrollLeft = slider.scrollLeft - 50;
    setFirstDate(moment(firstDate).subtract(1, "days"));
  };

  const slideRight = () => {
    let slider = document.getElementById("slider");
    slider.scrollLeft = slider.scrollLeft + 50;
    setFirstDate(moment(firstDate).add(1, "days"));
  };

  function onClickBookAppointment() {
    if (!selectedTimeSlot.slotId || !selectedTimeSlot.availabilityId) {
      openSnackbar
        ? openSnackbar({
            severity: "error",
            message: "Please select a time slot to continue",
          })
        : alert("Please select a time slot to continue");
      return;
    }

    const backendSlotId =
      selectedTimeSlot.originalSlotId || selectedTimeSlot.slotId;

    const appointmentData = {
      slotId: backendSlotId,
      availabilityId: selectedTimeSlot.availabilityId,
      clinicId,
      doctorId,
      date: new Date(selectedDate),
      startTime: selectedTimeSlot.startTime,
      endTime: selectedTimeSlot.endTime,
      type: visitType,
    };

    navigate("/bookingdetailsform", { state: appointmentData });
  }

  function handleBackToClinics() {
    setOpen(false);
    if (doctorId) {
      navigate(`/?id=${doctorId}`);
    } else {
      navigate(-1);
    }
  }

  return (
    <Modal
      isOpen={open}
      onRequestClose={() => setOpen(false)}
      style={customStyles}
    >
      <div className="booking_back_wrapper">
        <button className="booking_back_btn" onClick={handleBackToClinics}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.5 3.5L5 8L9.5 12.5"
              stroke="#194AF5"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>Back to clinics</span>
        </button>
      </div>

      <h1 className="booking_page_modal_header">Select Day & Date</h1>

      <div className="visit-type-toggle">
        <button
          className={visitType === "WALK IN" ? "active" : ""}
          onClick={() => setVisitType("WALK IN")}
        >
          Clinic Visit
        </button>
        <button
          className={visitType === "ONLINE" ? "active" : ""}
          onClick={() => setVisitType("ONLINE")}
        >
          Online Consultation
        </button>
      </div>

      <div className="booking_page_calender">
        {openCalender ? (
          <input
            type="date"
            value={new Date(selectedDate).toISOString().split("T")[0]}
            min={new Date().toISOString().split("T")[0]}
            onChange={(e) => {
              setSelectedDate(e.target.value);
              setFirstDate(e.target.value);
              setOpenCalender(!openCalender);
            }}
          />
        ) : (
          <div
            className="mt-1"
            onClick={() => {
              setOpenCalender(!openCalender);
              setTimeout(() => {
                document.querySelector("input[type='date']")?.showPicker();
              }, 0);
            }}
          >
            {moment(selectedDate).format("MMMM YYYY")}{" "}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M5.33333 1.33331V3.33331M10.6667 1.33331V3.33331M2.33333 6.05998H13.6667M14 5.66665V11.3333C14 13.3333 13 14.6666 10.6667 14.6666H5.33333C3 14.6666 2 13.3333 2 11.3333V5.66665C2 3.66665 3 2.33331 5.33333 2.33331H10.6667C13 2.33331 14 3.66665 14 5.66665Z"
                stroke="#194AF5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10.4634 9.13348H10.4694M10.4634 11.1335H10.4694M7.99669 9.13348H8.00336M7.99669 11.1335H8.00336M5.52936 9.13348H5.53602M5.52936 11.1335H5.53602"
                stroke="#194AF5"
                strokeWidth="1.33333"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        )}
      </div>

      <div className="booking_page_slider_container d-flex w-100 mt-5">
        <img
          className="booking_left_arrow"
          hidden={
            moment(firstDate).format("DD MM YYYY") ===
            moment().format("DD MM YYYY")
          }
          onClick={slideLeft}
          src={arrowLeft}
          alt=""
        />
        <div className="booking_page_slider_dates" id="slider">
          <DateSelector
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            currentMomentDate={moment(firstDate)}
            slots={slots}
          />
          <DateSelector
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            currentMomentDate={moment(moment(firstDate).add(1, "days"))}
            slots={slots}
          />
          <DateSelector
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            currentMomentDate={moment(moment(firstDate).add(2, "days"))}
            slots={slots}
          />
          <DateSelector
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            currentMomentDate={moment(moment(firstDate).add(3, "days"))}
            slots={slots}
          />
        </div>
        <img
          className="booking_right_arrow"
          onClick={slideRight}
          src={arrowRight}
          alt=""
        />
      </div>

      <h1 className="mt-4 booking_page_modal_header">Select Time Slot</h1>
      <div className="d-flex justify-content-evenly flex-wrap">
        <div className="date_selector_wrapper">
          {(() => {
            const dayName = moment(selectedDate).format("dddd").toUpperCase();
            const daySlots = slots[dayName] || [];
            const filteredSlots = filterUnavaliblity(daySlots);

            return filteredSlots?.length > 0 ? (
              filteredSlots.map((slot) => {
                const isOccupied = bookedSlots.some((range) => {
                  const slotStartM = moment(slot.startTime, "HH:mm");
                  const slotEndM = moment(slot.endTime, "HH:mm");
                  const bookedStart = moment(range.startTime, "HH:mm");
                  const bookedEnd = moment(range.endTime, "HH:mm");
                  return (
                    slotStartM.isBefore(bookedEnd) &&
                    slotEndM.isAfter(bookedStart)
                  );
                });

                return (
                  <Slot
                    key={slot._id}
                    id={slot._id}
                    originalSlotId={slot.originalSlotId}
                    availabilityId={slot.availabilityId}
                    startTime={slot.startTime}
                    endTime={slot.endTime}
                    disabled={isOccupied}
                    isOccupied={isOccupied}
                    setSelectedTimeSlot={setSelectedTimeSlot}
                    selectedTimeSlot={selectedTimeSlot}
                  />
                );
              })
            ) : (
              <div className="no-slots-message">No time slots available</div>
            );
          })()}
        </div>
      </div>

      <button
        className="booking_appointment_cta"
        onClick={onClickBookAppointment}
      >
        Book Appointment
      </button>
    </Modal>
  );
};

const DateSelector = ({
  selectedDate,
  currentMomentDate,
  setSelectedDate,
  slots,
}) => {
  const dayName = currentMomentDate.format("dddd").toUpperCase();
  const hasSlots = slots[dayName]?.length > 0;
  const isToday = currentMomentDate.isSame(moment(), "day");
  const isSelected = moment(selectedDate).isSame(currentMomentDate, "day");
  const isPast = currentMomentDate.isBefore(moment(), "day");

  return (
    <div
      style={{
        cursor: hasSlots && !isPast ? "pointer" : "not-allowed",
        backgroundColor:
          !hasSlots || isPast ? "#F3F3F3" : isSelected ? "#194AF5" : "#fff",
        color: !hasSlots || isPast ? "#999" : isSelected ? "#fff" : "#194AF5",
        opacity: isPast ? 0.5 : 1,
      }}
      className="day_input_label"
      onClick={() => {
        if (isPast) {
          alert("Cannot select past dates");
          return;
        }
        if (hasSlots) {
          setSelectedDate(currentMomentDate);
        } else {
          alert("No slots available on this day");
        }
      }}
    >
      <div style={{ position: "relative" }}>
        <div className="mb-1">
          <small className="today_text">{isToday ? "Today" : null}</small>
        </div>
        {currentMomentDate.format("ddd")}
        <div className="mt-1">{currentMomentDate.get("date")}</div>
      </div>
    </div>
  );
};

const Slot = ({
  id,
  originalSlotId,
  availabilityId,
  startTime,
  endTime,
  disabled,
  isOccupied,
  setSelectedTimeSlot,
  selectedTimeSlot,
}) => {
  const formatTo12Hour = (time24) => {
    if (!time24) return "";
    const [hours, minutes] = time24.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const hours12 = hours % 12 || 12;
    return `${hours12}:${minutes.toString().padStart(2, "0")} ${period}`;
  };

  return (
    <div
      key={id}
      style={{
        cursor: disabled ? "not-allowed" : "pointer",
        backgroundColor:
          selectedTimeSlot.slotId === id
            ? "#194AF5"
            : disabled
              ? "#FFEAEA"
              : "#fff",
        color:
          selectedTimeSlot.slotId === id
            ? "#fff"
            : disabled
              ? "#FF4D4D"
              : "#194AF5",
        border: disabled ? "1px solid #FF4D4D" : "1px solid #194AF5",
        position: "relative",
      }}
      className={`${disabled ? "date_input_label_disabled" : "date_input_label"}`}
      onClick={() => {
        if (disabled) {
          alert("This slot is already booked. Please choose another one.");
        } else {
          setSelectedTimeSlot({
            slotId: id,
            originalSlotId,
            availabilityId,
            startTime,
            endTime,
          });
        }
      }}
    >
      {formatTo12Hour(startTime)} - {formatTo12Hour(endTime)}
      {isOccupied && (
        <span style={{ fontSize: "8px", display: "block", color: "#FF4D4D" }}>
          Occupied
        </span>
      )}
    </div>
  );
};

export default BookingPage;
